import React, { useEffect } from 'react';
import { Drawer, Typography } from 'seagull';
import { NavLink } from 'react-router-dom';
import { useStore, useStoreActions } from "../../store/store-context";
import { getNotificationPresentationData } from "./InAppNotificationsDrawer.utils";
import { useEventReporter } from "../../event-reporter";
import { selectors } from "../../store/state-selectors";
import EmptyStateIllustration from "./InAppNotificationsEmptyStateIllustration.svg";
import styles from "./InAppNotificationsDrawer.module.scss";
import { timeModel } from "../../models";
export default function InAppNotificationsDrawer() {
  const {
    data
  } = useStore(state => state.inAppNotifications);
  const worksAt = useStore(selectors.user.business);
  const email = useStore(selectors.user.email);
  const inAppNotificationsDrawerOpen = useStore(state => state.inAppNotificationsDrawerOpen);
  const {
    api,
    logBI,
    fetchInAppNotifications,
    setInAppNotificationsDrawerOpen
  } = useStoreActions();
  const {
    reportToHeap
  } = useEventReporter();
  useEffect(() => {
    if (inAppNotificationsDrawerOpen && data) {
      const unseenNotificationIds = data.filter(pn => pn.id && !pn.seen).map(pn => pn.id);
      if ((unseenNotificationIds === null || unseenNotificationIds === void 0 ? void 0 : unseenNotificationIds.length) > 0) {
        api.inAppNotifications.markAsSeen(unseenNotificationIds);
      }
    }
  }, [inAppNotificationsDrawerOpen, data]);
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "notification-center"
  }, /*#__PURE__*/React.createElement(Drawer, {
    hasTopbar: true,
    header: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      weight: "bold"
    }, "Notifications center"), /*#__PURE__*/React.createElement(Typography, {
      skin: "secondary",
      variant: "paragraph3"
    }, worksAt === null || worksAt === void 0 ? void 0 : worksAt.name)),
    open: inAppNotificationsDrawerOpen,
    onClose: () => setInAppNotificationsDrawerOpen(false),
    onCloseButtonClick: () => setInAppNotificationsDrawerOpen(false),
    "data-testid": "notification-center-drawer",
    BackdropProps: {
      invisible: true
    }
  }, data !== null && data !== void 0 && data.length ? data === null || data === void 0 ? void 0 : data.map((notificationItem, index) => {
    const notificationData = getNotificationPresentationData(notificationItem);
    if (!notificationData) return null;
    const Element = notificationData.path ? NavLink : 'div';
    return /*#__PURE__*/React.createElement(Element, {
      to: notificationData.path,
      key: notificationItem.id,
      id: notificationItem.id,
      "data-testid": "notification-item-".concat(index),
      "data-heapid": "notification-item",
      onClick: async () => {
        const notificationType = notificationItem[notificationItem.type].type;
        logBI(15001, {
          notificationType
        });
        reportToHeap('notification-center', 'click', 'vendor-clicked-notification-item', {
          email,
          notificationType
        });
        if (!notificationItem.read) {
          api.inAppNotifications.markAsRead(notificationItem.id);
          await fetchInAppNotifications();
        }
      },
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.icon
    }, notificationData.icon), /*#__PURE__*/React.createElement("div", {
      className: styles.main
    }, /*#__PURE__*/React.createElement("div", {
      "data-testid": "notification-item-description-".concat(notificationData.type, "-").concat(index),
      "data-heapid": "notification-item-description"
    }, /*#__PURE__*/React.createElement(Typography, null, notificationData.content)), /*#__PURE__*/React.createElement("div", {
      "data-testid": "notification-item-time-ago-".concat(index),
      "data-heapid": "notification-item-time-ago"
    }, /*#__PURE__*/React.createElement(Typography, {
      skin: "secondary",
      variant: "paragraph3"
    }, timeModel.formatTimeAgo(notificationItem.timestamp)))), !notificationItem.read && /*#__PURE__*/React.createElement("div", {
      "data-testid": "read-item-dot",
      className: styles.readItemDotContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.readItemDot
    })));
  }) : /*#__PURE__*/React.createElement(InAppNotificationEmptyState, null)));
}
const InAppNotificationEmptyState = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.emptyState,
    "data-testid": "notification-center-drawer-empty-state"
  }, /*#__PURE__*/React.createElement(EmptyStateIllustration, null), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "You can sit down and relax"), /*#__PURE__*/React.createElement(Typography, null, "You have no notifications"));
};